export default __webpack_public_path__ + "static/media/malawi.b5335ce2.jpg";